import xs from 'xstream';
import BASE_URL from './variables';
import {
	requestGlobalPolicySearch,
	receiveGlobalPolicySearch,
	receiveGlobalPolicySearchError,
} from '../actions/applicationsAndPolicies';
import { REQUEST_GLOBAL_POLICY_SEARCH } from '../actions/index';

export function searchGlobalPolicies(sources) {
	const request$ = sources.ACTION
		.filter(action => action.type === REQUEST_GLOBAL_POLICY_SEARCH)
		.map(action => ({
			url: BASE_URL + 'api/GlobalPolicy/Search?searchTerm=' + encodeURIComponent(action.payload.searchTerm) + '&limit=' + action.payload.limit,
			category: 'globalPolicySearch',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));

	const httpResponse$ = sources.HTTP
		.select('globalPolicySearch')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => receiveGlobalPolicySearch(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function badResponseSearchGlobalPolicies(sources) {
	const httpResponse$ = sources.HTTP
		.select('globalPolicySearch')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
		.map(response => receiveGlobalPolicySearchError(response));

	return {
		ACTION: httpResponse$
	};
}
